

import { BasicDragVO } from "../vo/BasicDragVO";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
// TODO: @HTML5 unhandled getDefinitionByName, getQualifiedClassName
// import getDefinitionByName = createjs.getDefinitionByName;
// import getQualifiedClassName = createjs.getQualifiedClassName;

export class BasicDragManager {
    public dragVO: BasicDragVO = null;

    protected dragLayer: Container;

    protected _scaleMode: number = 1;
    protected _tempScaleMode: number = 0;
    protected _posX: number = 1;
    protected _posY: number = 1;
    protected _alpha: number = 1;

    constructor(_dragLayer: Container, scaleMode: number = 0, posX: number = 0, posY: number = 0, alpha: number = 1) {
        this.dragLayer = _dragLayer;

        if (scaleMode != 0) {
            this._scaleMode = scaleMode;
        }

        if (posX != 0) {
            this._posX = posX;
        }

        if (posY != 0) {
            this._posY = posY;
        }
        this._alpha = alpha;
    }

    public set scaleMode(value: number) {
        this._tempScaleMode = value;
    }

    /**
     * start drag by dragVO
     * get MovieClip by VO and added to dragLayer
     */
    public startDragging(_dragVO: BasicDragVO): void {
        this.dragVO = _dragVO;
        // TODO: @HTML5 unhandled getDefinitionByName, getQualifiedClassName
        // let dragMCClass: any = (<any>getDefinitionByName(getQualifiedClassName(this.dragVO.dragSourceMC)));
        // this.dragVO.dragMC = new (<MovieClip>dragMCClass);
        // this.dragVO.dragMC.mouseEnabled = false;

        if (this._tempScaleMode != 0) {
            this.dragVO.dragMC.scaleX = this._tempScaleMode;
            this.dragVO.dragMC.scaleY = this._tempScaleMode;
        }
        else {
            this.dragVO.dragMC.scaleX = this._scaleMode;
            this.dragVO.dragMC.scaleY = this._scaleMode;
        }

        // TODO: @HTML5 unhandled mouseX, mouseY, startDrag() in MovieClip class
        /*
        this.dragVO.dragMC.x = this.dragLayer.mouseX + this._posX;
        this.dragVO.dragMC.y = this.dragLayer.mouseY - this._posY;
        this.dragVO.dragSourceMC.alpha = this._alpha;
        this.dragVO.dragMC.startDrag();
        this.dragLayer.addChildAt(this.dragVO.dragMC, 0);
        */
    }

    /**
     * stopp current drag
     * and remove dragobject form dragLayer
     */
    public stopDragging(): void {
        if (!this.dragVO) {
            return;
        }
        this.dragVO.dragSourceMC.alpha = 1;
        this.dragLayer.removeChild(this.dragVO.dragMC);
        this.dragVO = null;
        this._tempScaleMode = 0;
    }

    /**
     * Determines whether there is a drag happening at the moment.
     * @return true if something is being dragged right now
     */
    public get isDragging(): boolean {
        return (this.dragVO != null);
    }

}

